export default "__VITE_ASSET__dlMlhHtw__"